export interface TourStep {
  title: string;
  description: string;
  gifUrl?: string;
  /** 'left' positions the card on the left side; 'center' for sidebar nav items */
  position: 'left' | 'center';
  /** If set, navigates to this path when the step becomes active */
  path?: string;
  /** Matches the sidebar nav item id to highlight it during this step */
  sidebarItemId?: string;
  /** Optional custom width (in Tailwind units, e.g., '900px') */
  customWidth?: string;
  /** Optional custom left offset (in Tailwind units, e.g., 'left-24') */
  customLeftOffset?: string;
}

export const SIDEBAR_TOUR_STEPS: TourStep[] = [
  // ── 1. Calendar ───────────────────────────────────────────────────
  {
    title: 'Calendar',
    description:
      'All bookings live here. Tap any empty time slot to start your first appointment.',
    gifUrl:
      'https://docs.nxcut.com/_next/static/media/1_appointment_booking.0et85s--glebi.gif',
    position: 'left',
    path: '/pos/calendar',
    sidebarItemId: 'calendar',
    customWidth: '850px',
    customLeftOffset: 'left-32',
  },

  // ── 2. Checkout ───────────────────────────────────────────────────
  {
    title: 'Checkout',
    description:
      'Completing checkout finalizes the sale. The payment is recorded and the sale appears in your reports automatically.',
    gifUrl:
      'https://docs.nxcut.com/_next/static/media/3_appointment_checkout.11n0byonz3irl.gif',
    position: 'left',
    customWidth: '850px',
    customLeftOffset: 'left-32',
    sidebarItemId: 'calendar',
  },

  // ── 3. Void a sale ────────────────────────────────────────────────
  {
    title: 'Void a Sale',
    description:
      'Reverses a completed sale and resets the appointment. Use it to undo a mistake or make corrections.',
    gifUrl:
      'https://docs.nxcut.com/_next/static/media/5_appointment_void.1222rrvdn.v6..gif',
    position: 'left',
    customWidth: '850px',
    customLeftOffset: 'left-32',
    sidebarItemId: 'calendar',
  },

  // ── 4. Catalog ────────────────────────────────────────────────────
  {
    title: 'Catalog',
    description:
      'Set up your services, products, memberships, and vouchers. Add these before booking appointments on the calendar.',
    position: 'center',
    path: '/pos/catalog',
    sidebarItemId: 'catalog',
  },

  // ── 5. Team ───────────────────────────────────────────────────────
  {
    title: 'Team Management',
    description:
      'Add your staff here. Team members must be in the system before they can be assigned to appointments on the calendar.',
    position: 'center',
    path: '/pos/team',
    sidebarItemId: 'team',
  },

  // ── 6. Settings ──────────────────────────────────────────────────
  {
    title: 'Settings',
    description:
      'Configure branch details, currency, payment methods, receipt layout, and set permissions for each team member.',
    position: 'center',
    path: '/pos/settings',
    sidebarItemId: 'settings',
  },

  // ── 7. Help & Docs ────────────────────────────────────────────────
  {
    title: 'Need Help?',
    description:
      'Look for the ? icon in the sidebar. Tap it anytime to open the help docs for that section. This gives you instant access to guides and documentation without leaving the app.',
    position: 'center',
    path: '/pos/settings/branches',
    sidebarItemId: 'help-docs',
  },
];
